// 当前的navConfig是否是文字链Item，如果nav为空，则非文字链Item
export function isTextTypeNav(navConfig) {
  return navConfig?.isCampaignTextNav || ['textLink'].includes(navConfig?.type);
}
